const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export const getYouTubeVideoId = (urlValue?: string | null): string | null => {
  if (!urlValue?.trim()) {
    return null;
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(urlValue.trim());
  } catch {
    return null;
  }

  const protocol = parsedUrl.protocol.toLowerCase();
  if (protocol !== "http:" && protocol !== "https:") {
    return null;
  }

  const hostname = parsedUrl.hostname.toLowerCase();
  const normalizedHostname = hostname.startsWith("www.")
    ? hostname.slice(4)
    : hostname;

  let videoId = "";

  if (normalizedHostname === "youtu.be") {
    videoId = parsedUrl.pathname.split("/").filter(Boolean)[0] ?? "";
  } else if (normalizedHostname === "youtube.com") {
    if (parsedUrl.pathname === "/watch") {
      videoId = parsedUrl.searchParams.get("v") ?? "";
    } else {
      const [segment, id] = parsedUrl.pathname
        .split("/")
        .filter((segmentValue: string) => segmentValue.length > 0);
      if (segment === "embed" || segment === "shorts" || segment === "live") {
        videoId = id ?? "";
      }
    }
  }

  return YOUTUBE_VIDEO_ID_PATTERN.test(videoId) ? videoId : null;
};

export const isYouTubeUrl = (urlValue?: string | null): boolean => {
  return !!getYouTubeVideoId(urlValue);
};

export const getYouTubeEmbedUrl = (urlValue?: string | null): string | null => {
  const videoId = getYouTubeVideoId(urlValue);
  if (!videoId) {
    return null;
  }

  return `https://www.youtube.com/embed/${videoId}`;
};

export const getYouTubeThumbnailUrl = (
  urlValue?: string | null,
): string | null => {
  const videoId = getYouTubeVideoId(urlValue);
  if (!videoId) {
    return null;
  }

  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
};
